const STORAGE_KEY = "hey-jerry:auth:return-to";

const isSafeDestination = (candidate: string) => {
  if (!candidate.startsWith("/") || candidate.startsWith("//")) return false;
  try {
    const parsed = new URL(candidate, window.location.origin);
    return parsed.origin === window.location.origin && parsed.pathname !== "/auth/signin";
  } catch {
    return false;
  }
};

export const saveAuthReturnDestination = (destination: string) => {
  if (!isSafeDestination(destination)) return false;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, destination);
    return true;
  } catch {
    return false;
  }
};

export const consumeAuthReturnDestination = () => {
  try {
    const destination = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return destination && isSafeDestination(destination) ? destination : null;
  } catch {
    return null;
  }
};

export const clearAuthReturnDestination = () => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage may be unavailable in private browsing; the current navigation can still finish.
  }
};
